(async () => {
    const { Core } = await importModule('Core');

   const DEFAULT_CURRENCY_DECIMALS = 0;

/**
 * Decimal precision for currencies that have a non-default precision
 * @type {Record<string, number>}
 */
const CURRENCY_DECIMALS = {
  BHD: 3,
  BIF: 0,
  BYR: 0,
  CLF: 4,
  CLP: 0,
  DJF: 0,
  GNF: 0,
  IQD: 3,
  ISK: 0,
  JOD: 3,
  JPY: 0,
  KMF: 0,
  KRW: 0,
  KWD: 3,
  LYD: 3,
  MRO: 5,
  OMR: 3,
  PYG: 0,
  RWF: 0,
  TND: 3,
  UGX: 0,
  UYI: 0,
  UYW: 4,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XAG: 0,
  XAU: 0,
  XBA: 0,
  XBB: 0,
  XBC: 0,
  XBD: 0,
  XDR: 0,
  XOF: 0,
  XPD: 0,
  XPF: 0,
  XPT: 0,
  XSU: 0,
  XTS: 0,
  XUA: 0,
};

  
    customElements.define('collection-filter-price', class extends Core {
        elements = {
            inputMin: '[data-element="input-min"]',
            inputMax: '[data-element="input-max"]',
            priceMin: '[data-element="price-min"]',
            priceMax: '[data-element="price-max"]'
        }

        render() {
            this._initSlider();
        }
        
        _initSlider() {
            this.$inputMin.addEventListener('change', this._sliderChangeHadler.bind(this));
            this.$inputMin.addEventListener('input', this._handleInput.bind(this));
            this.$inputMax.addEventListener('change', this._sliderChangeHadler.bind(this));
            this.$inputMax.addEventListener('input', this._handleInput.bind(this));
        }

  _formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision) {
    const roundedNumber = (moneyValue / 100).toFixed(precision);

    let [a, b] = roundedNumber.split('.');
    if (!a) a = '0';
    if (!b) b = '';

    // Split by groups of 3 digits
    a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (digit) => digit + thousandsSeparator);

    return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
  }
      
    _formatMoney(moneyValue) {
    const template = this.dataset.moneyFormat || '{{amount}}';
    const currency = this.dataset.currency || '';
    return template.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
      if (typeof placeholder !== 'string') return '';

      let thousandsSeparator = ',';
      let decimalSeparator = '.';
      let precision = CURRENCY_DECIMALS[currency.toUpperCase()] ?? DEFAULT_CURRENCY_DECIMALS;

      if (placeholder === 'amount') {
        // Check first since it's the most common, use defaults.
      } else if (placeholder === 'amount_no_decimals') {
        precision = 0;
      } else if (placeholder === 'amount_with_comma_separator') {
        thousandsSeparator = '.';
        decimalSeparator = ',';
      } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
        // Weirdly, this is correct. It uses amount_with_comma_separator's
        // behaviour but removes decimals, resulting in an unintuitive
        // output that can't possibly include commas, despite the name.
        thousandsSeparator = '.';
        precision = 0;
      } else if (placeholder === 'amount_no_decimals_with_space_separator') {
        thousandsSeparator = ' ';
        precision = 0;
      } else if (placeholder === 'amount_with_space_separator') {
        thousandsSeparator = ' ';
        decimalSeparator = ',';
      } else if (placeholder === 'amount_with_period_and_space_separator') {
        thousandsSeparator = ' ';
        decimalSeparator = '.';
      } else if (placeholder === 'amount_with_apostrophe_separator') {
        thousandsSeparator = "'";
        decimalSeparator = '.';
      }

      return this._formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision);

      });
  }
        _sliderChangeHadler() {
            this.publish('filter:change');
        }

        _handleInput({ target }) {
            this._checkInputsIntersection(target);
            this._setRangeStyles();
            
        }
    
        _checkInputsIntersection(target) {
            if (target === this.$inputMin && this.minValue > this.maxValue) {
                this.$inputMin.value = this.maxValue;
            }
            if (target === this.$inputMax && this.maxValue < this.minValue) {
                this.$inputMax.value = this.minValue;
            }
            if(target.getAttribute("data-element") == "input-min"){
              this.$priceMin.innerHTML = this._formatMoney(target.value * 100);
            }else{
              this.$priceMax.innerHTML = this._formatMoney(target.value * 100);
            }          
        }

        _setRangeStyles() {
            const rangeMin = this.minValue / this.rangePercent;
            const rangeMax = this.maxValue / this.rangePercent;
            this.style.setProperty('--range-min', `${rangeMin}%`);
            this.style.setProperty('--range-max', `${rangeMax}%`);
        }

        get rangePercent() {
            return this.getAttribute('range-percent');
        }
        get minValue() {
            return this.$inputMin.valueAsNumber;
        }
        get maxValue() {
            return this.$inputMax.valueAsNumber;
        }
    })
})();
